import React from "react";
import { MenuItem } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import TableChart from "@mui/icons-material/TableChart";
import People from "@mui/icons-material/People";
import Schedule from "@mui/icons-material/Schedule";
import NotificationsActive from "@mui/icons-material/NotificationsActive";
import Rule from "@mui/icons-material/Rule";
import SensorsIcon from "@mui/icons-material/Sensors";
import ConfigurationIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";

export interface ConfigMenuItemProps {
  ckey: string;
  pathname: string;
  handleClose: () => void;
  onItemClick?: () => void;
}
export const getConfigMenuIcon = (
  id:
    | "skuTable"
    | "users"
    | "shiftSchedules"
    | "alertRules"
    | "adlRules"
    | "sense"
) => {
  if (id === "skuTable") {
    return <TableChart />;
  } else if (id === "users") {
    return <People />;
  } else if (id === "shiftSchedules") {
    return <Schedule />;
  } else if (id === "alertRules") {
    return <NotificationsActive />;
  } else if (id === "adlRules") {
    return <Rule />;
  } else if (id === "sense") {
    return <SensorsIcon />;
  }
  return <ConfigurationIcon />;
};
export const ConfigMenuItems: React.FC<ConfigMenuItemProps> = ({
  ckey,
  pathname,
  handleClose,
  onItemClick,
}) => {
  const { translate } = useFlightTranslation();

  const menuItems = [
    {
      id: "skuTable",
      label: "SKUs",
      icon: getConfigMenuIcon("skuTable"),
      action: "navigate-to-sku-table",
    },
    {
      id: "shiftSchedules",
      label: "Shift Schedules",
      icon: getConfigMenuIcon("shiftSchedules"),
      action: "navigate-to-shift-schedules",
    },
    {
      id: "alertRules",
      label: "Alert Rules",
      icon: getConfigMenuIcon("alertRules"),
      action: "navigate-to-alert-rules",
    },
    {
      id: "adlRules",
      label: "ADL Rules",
      icon: getConfigMenuIcon("adlRules"),
      action: "navigate-to-adl-rules",
    },
    {
      id: "sense",
      label: "Sense Configs",
      icon: getConfigMenuIcon("sense"),
      action: "navigate-to-sense-devices",
    },
    {
      id: "users",
      label: "Users",
      icon: getConfigMenuIcon("users"),
      action: "navigate-to-users",
    },
  ];

  return (
    <>
      {menuItems.map(item => (
        <MenuItem
          key={item.id}
          onClick={() => {
            handleClose();
            if (onItemClick) {
              onItemClick();
            }
            ReactGA.event({
              category: "navigation",
              action: item.action,
            });
          }}
          component={Link}
          to={`/${ckey}/config/${item.id}`}
          disabled={pathname.includes(`/config/${item.id}`)}
          className={`config-menu-item-${item.id}`}
          style={{
            backgroundColor: pathname.includes(`/config/${item.id}`)
              ? "#f5f5f5"
              : "inherit",
          }}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          {translate(item.label)}
        </MenuItem>
      ))}
    </>
  );
};
